import ViewProjectAsDeveloper from "./components/developer/DeveloperViewProject";
import NoMatch from "./components/NoMatch";
import Drawings from "./components/files/Drawings";
import FindBidderView from "./components/projects/ProjectBidders";
import ViewProjectAsBuilder from "./components/builder/ViewProjectBuilder";
import CreateProjectForm from "./components/projects/CreateProject";

import {Navigate, RouteObject} from "react-router-dom";

import AppLayout from "./App.layout";

import {lazy} from "react";
import CompanySetup from "./components/CompanySetup/CompanySetup";
import {whoAmIResponse} from "@models/project";
import UserProfile from "./components/admin/Profile";
import EditProject from "./components/developer/EditProject";
import OwnUserProfile from "./components/admin/OwnProfile";
import ProjectDirectoryView from "./components/Directory";
import CompanyDirectoryView from "./components/admin/CompanyDirectory";
import CompanyBaseView from "./components/admin/CompanyBaseView";
import DeveloperVeView from "./components/ve/veDeveloper";
import ProjectConfig from "./components/project_conf/ProjectConfig";
import BidView from "./components/bid/BidView";
import UserManagementView from "./components/admin/UserManagementView";
import QAPage from "./components/qa_forum/QAPage";
import QAThread from "./components/qa_forum/QAThread";
import BidSummary from "./components/bid/BiddingSummaryView";
import Docs from './components/admin/docs'
import BidChart from "./components/bid/BidChart";
import CompareBids from "./components/developer/compareBids";
import NotificationHome from "./components/notification/NotificationHome";
import {CompanyType} from "./models/company";
import GeneralProjectsInfo from "./components/projects/GeneralProjectsInfo";


function _CommonRoutes (){
    return  [
        {
            path: "*",
            element: <NoMatch />,
        },
        {
            path: "profile", // own user profile
            element: <OwnUserProfile />,
        },
        {
            path: "profile/:user", // other user profiles
            element: <UserProfile />,
        },
        /**
         *
         * */
        {
            path: "company/{company_id}", // view another company's profile
            element: <NoMatch />,
        },
        {
            path: "company/directory",
            element: <CompanyDirectoryView />,
        },
        {
            path: "company/profile",
            element: <CompanyDirectoryView />,
        },
        {
            path: "company/project-config",
            element: <NoMatch />,
        },
        {
            path: "project/:project_id/qa",
            element: <QAPage creating={false}/>,
        },
        {
            path: "project/:project_id/qa/:qa_id",
            element: <QAThread />,
        },
        {
            path: "/project/:project_id/bidding-chart",
            element: <BidChart/>,
        },
        {
            path: "/projects",
            element: <GeneralProjectsInfo />,
        },
        {
            path: "company/manage/:user_id",
            element: <UserManagementView />,
        },
        {
            path: "notifications",
            element: <NotificationHome />,
        },
         {
            path: "docs",
            element: <Docs />,
        },
    ];
}

function _BuilderRoutes(){
    const BuilderHome = lazy(() => import("./components/builder/BuilderHome"));
    const BuilderVeView = lazy(() => import("./components/ve/veBuilder") );
    return [
            {
                path: "/",
                element: <BuilderHome />,
            },
            {
                path: "/company", // own - company profile admin
                element: <CompanyBaseView />,
            },
            {
                path: "/project",
                element: <BuilderHome />,
                // lazy: true // todo - figure out what this does
            },
            {
                path: "/project/:project_id",
                element: <ViewProjectAsBuilder />,
            },

            {
                path: "/project/:project_id/documents",
                element: <Drawings />,
            },
            {
                path: "project/:project_id/qa/new",
                element: <QAPage creating={true}/>,
            },
            /**
             *
             * */
            {
                path: "/project/:project_id/bid/:bid_id",
                element: <BidView editable={true} create={false} />,
            },
            /** * */
            {
                path: "/project/:project_id/bidders",
                element: <BidSummary />,
            },
            {
                key: "ve_list",
                path: "/project/:project_id/ve",
                element: <BuilderVeView />,
            },
            {
                path: "/project/:project_id/ve/:ve_id",
                element: <BuilderVeView />,
            },
            /**
             *
             * */
            {
                path: "/project/:project_id/directory",
                element: <ProjectDirectoryView />,
            },
            {
                path: "/project/:project_id/settings",
                element: <NoMatch />,
            },

            {
                path: "/project/:project_id/edit",
                element: <EditProject />,
            },
            ..._CommonRoutes(),
        ];
}


function _DeveloperRoutes(){
     const DeveloperHome = lazy(
            () => import("./components/developer/DeveloperHome")
        );

        return [
            {
                path: "/",
                element: <DeveloperHome />,
            },
            {
                path: "/company", // own - company profile admin
                element: <CompanyBaseView />,
            },
            {
                path: "/search",
                element: <FindBidderView />, // todo this should be a slightly different view ....
            },
            {
                path: "/project",
                element: <DeveloperHome />, // todo this should be a table of projects
            },
            {
                path: "/project/create",
                element: <CreateProjectForm project={null} project_id={null} />,
            },
            {
                path: "/project/:project_id",
                element: <ViewProjectAsDeveloper />,
            },
            {
                path: "/project/:project_id/edit",
                element: <EditProject />,
            },
            {
                path: "/project/:project_id/documents", // this should be context for project files
                element: <Drawings />,
            },
            {
                path: "/project/:project_id/bidders",
                element: <BidSummary  />, // <FindBidderView />,
            },
             {
                path: "/project/:project_id/bidding/compare",
                element: <CompareBids  />,
            },
            /** * */
            {
                path: "/project/:project_id/bid/:bid_id",
                element: <BidView editable={false} create={false} />,
            },
            /** * */
            {
                path: "/project/:project_id/ve",
                element: <DeveloperVeView />,
            },
            {
                path: "/project/:project_id/ve/:ve_id",
                element: <DeveloperVeView />,
            },
            /** * */
            {
                path: "/project/:project_id/directory",
                element: <ProjectDirectoryView />,
            },
            {
                path: "/project/:project_id/config",
                element: <ProjectConfig />,
            },
            ..._CommonRoutes(),
        ];
}

function _BrokerRoutes(){
    return [

    ]
}


function routeConstructor(role: whoAmIResponse) {
    if (role.company_type === "builder") {
        return _BuilderRoutes()

    } else if (role.company_type === CompanyType.developer ) {
       return _DeveloperRoutes()

    } else if ( role.company_type === CompanyType.broker) {
       return [..._DeveloperRoutes(), ... _BrokerRoutes()]

    } else if (role.company_type === "not_set") {
        return [
            {
                path: "/*",
                element: (
                    <Navigate to="/company-setup" state={{ whoAmI: role }} />
                ),
            },
            {
                path: "/company-setup",
                element: <CompanySetup />,
            },
        ];
    } else {
        return [];
    }
}

// I should pass down more stuff?
const RouterBuilder = (role: whoAmIResponse) => {
    const routes: RouteObject[] = [
        {
            element: <AppLayout role={role} />,
            children: routeConstructor(role),
        },
    ];

    return routes;
};

export default RouterBuilder;

// const navigation = useNavigation();
// THIS IS HOW WE DO IT: https://github.com/remix-run/react-router/discussions/8308

// ok ... nvmd - we are gonna do stuff with routes here
// do the whoAmI call here ....
// https://stackoverflow.com/questions/48497510/simple-conditional-routing-in-reactjs
// also do it this way https://www.robinwieruch.de/react-router-nested-routes/
// nested routes area thing...
// const [isAuthenticated, setIsAuthenticated] = useState(false);
// const setAuth = (boolean) => {
//     setIsAuthenticated(boolean);
